import { Injectable } from '@angular/core';
import {
    ClfMeetingContext,
    LOCALSTORAGEKEYS,
} from '../../_constants/localStorageKeys';
import { roles } from '../../_constants/roles';
import { LocalService } from '../_storage/local.service';

@Injectable({ providedIn: 'root' })
export class RoleAccessService {
    constructor(private localService: LocalService) {}

    private getActiveGeoLevel(): string {
        const ctx = this.localService.get<ClfMeetingContext>(
            LOCALSTORAGEKEYS.CLF_MEETING_CONTEXT
        );
        return ctx?.activeGeoLevel || '';
    }

    canEditClfMeeting(): boolean {
        return this.getActiveGeoLevel() === 'CLF';
    }

    canApproveRejectMeeting(): boolean {
        if (this.getActiveGeoLevel() !== 'Block') return false;
        const userRoles =
            this.localService.get<string[]>(LOCALSTORAGEKEYS.USERROLES) || [];
        return userRoles.includes(roles.BMIB);
    }
}
